<template>
    <div class="alert alert-success" role="alert">
        Saved Successfully!
    </div>
</template>


<style scoped>

</style>